import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "portfolio" }
const _hoisted_2 = { id: "portfolio" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "title text-center" }, "Our portfolio", -1)
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "overlay" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-arrow-up-right2" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", {
  class: "portfolio-link portfolio-link-always-visible",
  style: {}
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "overlay overlay-always-visible" }, [
  /*#__PURE__*/_createVNode("i", { class: "icon-arrow-right2" }),
  /*#__PURE__*/_createVNode("span", { class: "show-more" }, "Show More")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PortfolioModal = _resolveComponent("PortfolioModal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.portfolioItemsView, (item, key) => {
          return (_openBlock(), _createBlock("div", {
            class: "portfolio-box",
            key: key,
            onClick: ($event: any) => (_ctx.portfolioBoxClicked(item.pid))
          }, [
            _createVNode("span", {
              class: "portfolio-link",
              style: { backgroundImage: 'url(' + item.thumb + ')' }
            }, null, 4),
            _hoisted_5
          ], 8, ["onClick"]))
        }), 128)),
        _withDirectives(_createVNode("div", {
          class: "portfolio-box",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMoreItems()))
        }, [
          _hoisted_6,
          _hoisted_7
        ], 512), [
          [_vShow, _ctx.numberOfItemsToDisplay < _ctx.portfolioItems.length]
        ])
      ]),
      _createVNode(_component_PortfolioModal, { item: _ctx.modalItem }, null, 8, ["item"])
    ])
  ]))
}